import { trackStructEvent } from "@snowplow/browser-tracker";

import { AddToWishlistContext, Events, WishlistContext } from "./../types";
import { submitSPEvents } from "./emitSnowplowEvent";

type EmitAddToWishlistProps = AddToWishlistContext["options"] &
  WishlistContext["options"] & {
    action?: "Add" | "Remove";
  };

export function emitAddToWishlist({
  product_id,
  page_type,
  wishlist,
  action = "Add",
  position,
  quantity,
  source_type,
  event_id,
  event_title,
}: EmitAddToWishlistProps) {
  trackStructEvent({
    category: "wishlist",
    action,
    property: "wishlist",
  });

  const events: (AddToWishlistContext | WishlistContext)[] = [
    {
      context: Events.WISHLIST,
      options: {
        page_type,
        product_id,
      },
    },
  ];

  if (wishlist && action === "Add") {
    events.push({
      context: Events.ADD_TO_WISHLIST,
      options: {
        wishlist,
        position,
        quantity,
        source_type,
        event_id,
        event_title,
      },
    });
  }

  submitSPEvents<AddToWishlistContext | WishlistContext>(events);
}
